import { render, staticRenderFns } from "./ManufacturerInput.vue?vue&type=template&id=41b67165&"
import script from "./ManufacturerInput.vue?vue&type=script&lang=js&"
export * from "./ManufacturerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports